// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.1
//   protoc               v3.21.12
// source: stream_list.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { share } from "rxjs/operators";

export const protobufPackage = "youtube.api.v3";

export interface LiveChatMessageListRequest {
  /** The ID of the live chat for which comments should be returned. */
  liveChatId?:
    | string
    | undefined;
  /**
   * Specifies the localization language in which the system messages
   * should be returned.
   */
  hl?:
    | string
    | undefined;
  /**
   * Specifies the size of the profile image that should be
   * returned for each user.
   */
  profileImageSize?:
    | number
    | undefined;
  /**
   * The <code><strong>maxResults</strong></code> parameter specifies the
   * maximum number of items that should be returned in the result set.
   * Not used in the streaming RPC.
   */
  maxResults?:
    | number
    | undefined;
  /**
   * The <code><strong>pageToken</strong></code> parameter identifies a specific
   * page in the result set that should be returned. In an API response, the
   * <code>nextPageToken</code> property identify other pages that could be
   * retrieved.
   */
  pageToken?:
    | string
    | undefined;
  /**
   * The <code><strong>part</strong></code> parameter specifies the
   * <code>liveChatComment</code> resource parts that the API response will
   * include. Supported values are <code>id</code>, <code>snippet</code>, and
   * <code>authorDetails</code>.
   */
  part: string[];
}

export interface LiveChatMessageListResponse {
  /**
   * Identifies what kind of resource this is. Value: the fixed string
   * <code>"youtube#liveChatMessageListResponse"</code>.
   */
  kind?:
    | string
    | undefined;
  /** Etag of this resource. */
  etag?:
    | string
    | undefined;
  /**
   * The date and time when the underlying stream went offline. The value is
   * specified in <a href="//www.w3.org/TR/NOTE-datetime">ISO 8601</a>
   * format.
   */
  offlineAt?:
    | string
    | undefined;
  /** General pagination information. */
  pageInfo?: PageInfo | undefined;
  nextPageToken?: string | undefined;
  items: LiveChatMessage[];
  /** Set when there is an active poll. */
  activePollItem?: LiveChatMessage | undefined;
}

export interface LiveChatMessage {
  /**
   * Identifies what kind of resource this is. Value: the fixed string
   * <code>"youtube#liveChatMessage"</code>.
   */
  kind?:
    | string
    | undefined;
  /** Etag of this resource. */
  etag?:
    | string
    | undefined;
  /** The ID that YouTube assigns to uniquely identify the message. */
  id?:
    | string
    | undefined;
  /** The <code>snippet</code> object contains basic details about the message. */
  snippet?:
    | LiveChatMessageSnippet
    | undefined;
  /**
   * The <code>authorDetails</code> object contains basic details about the
   * user that posted this message.
   */
  authorDetails?: LiveChatMessageAuthorDetails | undefined;
}

export interface LiveChatMessageAuthorDetails {
  /** The YouTube channel ID. */
  channelId?:
    | string
    | undefined;
  /** The channel's URL. */
  channelUrl?:
    | string
    | undefined;
  /** The channel's display name. */
  displayName?:
    | string
    | undefined;
  /** The channels's avatar URL. */
  profileImageUrl?:
    | string
    | undefined;
  /** Whether the author's identity has been verified by YouTube. */
  isVerified?:
    | boolean
    | undefined;
  /** Whether the author is the owner of the live chat. */
  isChatOwner?:
    | boolean
    | undefined;
  /** Whether the author is a sponsor of the live chat. */
  isChatSponsor?:
    | boolean
    | undefined;
  /** Whether the author is a moderator of the live chat. */
  isChatModerator?: boolean | undefined;
}

export interface LiveChatMessageSnippet {
  /**
   * The type of message, this will always be present, it determines the
   * contents of the message as well as which fields will be present.
   */
  type?: LiveChatMessageSnippet_TypeWrapper_Type | undefined;
  liveChatId?:
    | string
    | undefined;
  /**
   * The ID of the user that authored this message, this field is not always
   * filled.
   * textMessageEvent - the user that wrote the message
   * fanFundingEvent - the user that funded the broadcast
   * newSponsorEvent - the user that just became a sponsor
   * memberMilestoneChatEvent - the member that sent the message
   * membershipGiftingEvent - the user that made the purchase
   * giftMembershipReceivedEvent - the user that received the gift membership
   * messageDeletedEvent - the moderator that took the action
   * messageRetractedEvent - the author that retracted their message
   * userBannedEvent - the moderator that took the action
   * superChatEvent - the user that made the purchase
   * superStickerEvent - the user that made the purchase
   * pollEvent - the user that created the poll
   */
  authorChannelId?:
    | string
    | undefined;
  /**
   * The date and time when the message was orignally published. The value is
   * specified in <a href="//www.w3.org/TR/NOTE-datetime">ISO 8601</a>
   * format.
   */
  publishedAt?:
    | string
    | undefined;
  /** Whether the message has display content that should be displayed to users. */
  hasDisplayContent?:
    | boolean
    | undefined;
  /**
   * Contains a string that can be displayed to the user.
   * If this field is not present the message is silent, at the moment only
   * messages of type TOMBSTONE and CHAT_ENDED_EVENT are silent.
   */
  displayMessage?:
    | string
    | undefined;
  /**
   * Details about the text message, this is only set if the type is
   * 'textMessageEvent'.
   */
  textMessageDetails?: LiveChatTextMessageDetails | undefined;
  messageDeletedDetails?: LiveChatMessageDeletedDetails | undefined;
  messageRetractedDetails?: LiveChatMessageRetractedDetails | undefined;
  userBannedDetails?:
    | LiveChatUserBannedMessageDetails
    | undefined;
  /**
   * Details about the Super Chat event, this is only set if the type is
   * 'superChatEvent'.
   */
  superChatDetails?:
    | LiveChatSuperChatDetails
    | undefined;
  /**
   * Details about the Super Sticker event, this is only set if the type is
   * 'superStickerEvent'.
   */
  superStickerDetails?:
    | LiveChatSuperStickerDetails
    | undefined;
  /**
   * Details about the New Member Announcement event, this is only set if
   * the type is 'newSponsorEvent'. Note that "member" is the new term for
   * "sponsor".
   */
  newSponsorDetails?:
    | LiveChatNewSponsorDetails
    | undefined;
  /**
   * Details about the Member Milestone Chat event, this is only set if
   * the type is 'memberMilestoneChatEvent'.
   */
  memberMilestoneChatDetails?:
    | LiveChatMemberMilestoneChatDetails
    | undefined;
  /**
   * Details about the Membership Gifting event, this is only set if the type
   * is 'membershipGiftingEvent'.
   */
  membershipGiftingDetails?:
    | LiveChatMembershipGiftingDetails
    | undefined;
  /**
   * Details about the Gift Membership Received event, this is only set if the
   * type is 'giftMembershipReceivedEvent'.
   */
  giftMembershipReceivedDetails?:
    | LiveChatGiftMembershipReceivedDetails
    | undefined;
  /**
   * Details about the poll event, this is only set if the type is
   * 'pollEvent'.
   */
  pollDetails?: LiveChatPollDetails | undefined;
}

export type LiveChatMessageSnippet_TypeWrapper = {}

export enum LiveChatMessageSnippet_TypeWrapper_Type {
  INVALID_TYPE = 0,
  TEXT_MESSAGE_EVENT = 1,
  TOMBSTONE = 2,
  FAN_FUNDING_EVENT = 3,
  CHAT_ENDED_EVENT = 4,
  SPONSOR_ONLY_MODE_STARTED_EVENT = 5,
  SPONSOR_ONLY_MODE_ENDED_EVENT = 6,
  NEW_SPONSOR_EVENT = 7,
  MEMBER_MILESTONE_CHAT_EVENT = 17,
  MEMBERSHIP_GIFTING_EVENT = 18,
  GIFT_MEMBERSHIP_RECEIVED_EVENT = 19,
  MESSAGE_DELETED_EVENT = 8,
  MESSAGE_RETRACTED_EVENT = 9,
  USER_BANNED_EVENT = 10,
  SUPER_CHAT_EVENT = 15,
  SUPER_STICKER_EVENT = 16,
  POLL_EVENT = 20,
  UNRECOGNIZED = -1,
}

export function liveChatMessageSnippet_TypeWrapper_TypeFromJSON(object: any): LiveChatMessageSnippet_TypeWrapper_Type {
  switch (object) {
    case 0:
    case "INVALID_TYPE":
      return LiveChatMessageSnippet_TypeWrapper_Type.INVALID_TYPE;
    case 1:
    case "TEXT_MESSAGE_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.TEXT_MESSAGE_EVENT;
    case 2:
    case "TOMBSTONE":
      return LiveChatMessageSnippet_TypeWrapper_Type.TOMBSTONE;
    case 3:
    case "FAN_FUNDING_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.FAN_FUNDING_EVENT;
    case 4:
    case "CHAT_ENDED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.CHAT_ENDED_EVENT;
    case 5:
    case "SPONSOR_ONLY_MODE_STARTED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.SPONSOR_ONLY_MODE_STARTED_EVENT;
    case 6:
    case "SPONSOR_ONLY_MODE_ENDED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.SPONSOR_ONLY_MODE_ENDED_EVENT;
    case 7:
    case "NEW_SPONSOR_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.NEW_SPONSOR_EVENT;
    case 17:
    case "MEMBER_MILESTONE_CHAT_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.MEMBER_MILESTONE_CHAT_EVENT;
    case 18:
    case "MEMBERSHIP_GIFTING_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.MEMBERSHIP_GIFTING_EVENT;
    case 19:
    case "GIFT_MEMBERSHIP_RECEIVED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.GIFT_MEMBERSHIP_RECEIVED_EVENT;
    case 8:
    case "MESSAGE_DELETED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.MESSAGE_DELETED_EVENT;
    case 9:
    case "MESSAGE_RETRACTED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.MESSAGE_RETRACTED_EVENT;
    case 10:
    case "USER_BANNED_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.USER_BANNED_EVENT;
    case 15:
    case "SUPER_CHAT_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.SUPER_CHAT_EVENT;
    case 16:
    case "SUPER_STICKER_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.SUPER_STICKER_EVENT;
    case 20:
    case "POLL_EVENT":
      return LiveChatMessageSnippet_TypeWrapper_Type.POLL_EVENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LiveChatMessageSnippet_TypeWrapper_Type.UNRECOGNIZED;
  }
}

export function liveChatMessageSnippet_TypeWrapper_TypeToJSON(object: LiveChatMessageSnippet_TypeWrapper_Type): string {
  switch (object) {
    case LiveChatMessageSnippet_TypeWrapper_Type.INVALID_TYPE:
      return "INVALID_TYPE";
    case LiveChatMessageSnippet_TypeWrapper_Type.TEXT_MESSAGE_EVENT:
      return "TEXT_MESSAGE_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.TOMBSTONE:
      return "TOMBSTONE";
    case LiveChatMessageSnippet_TypeWrapper_Type.FAN_FUNDING_EVENT:
      return "FAN_FUNDING_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.CHAT_ENDED_EVENT:
      return "CHAT_ENDED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.SPONSOR_ONLY_MODE_STARTED_EVENT:
      return "SPONSOR_ONLY_MODE_STARTED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.SPONSOR_ONLY_MODE_ENDED_EVENT:
      return "SPONSOR_ONLY_MODE_ENDED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.NEW_SPONSOR_EVENT:
      return "NEW_SPONSOR_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.MEMBER_MILESTONE_CHAT_EVENT:
      return "MEMBER_MILESTONE_CHAT_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.MEMBERSHIP_GIFTING_EVENT:
      return "MEMBERSHIP_GIFTING_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.GIFT_MEMBERSHIP_RECEIVED_EVENT:
      return "GIFT_MEMBERSHIP_RECEIVED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.MESSAGE_DELETED_EVENT:
      return "MESSAGE_DELETED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.MESSAGE_RETRACTED_EVENT:
      return "MESSAGE_RETRACTED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.USER_BANNED_EVENT:
      return "USER_BANNED_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.SUPER_CHAT_EVENT:
      return "SUPER_CHAT_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.SUPER_STICKER_EVENT:
      return "SUPER_STICKER_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.POLL_EVENT:
      return "POLL_EVENT";
    case LiveChatMessageSnippet_TypeWrapper_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LiveChatTextMessageDetails {
  /** The user's message. */
  messageText?: string | undefined;
}

export interface LiveChatMessageDeletedDetails {
  deletedMessageId?: string | undefined;
}

export interface LiveChatMessageRetractedDetails {
  retractedMessageId?: string | undefined;
}

export interface LiveChatUserBannedMessageDetails {
  /** The details of the user that was banned. */
  bannedUserDetails?:
    | ChannelProfileDetails
    | undefined;
  /** The type of ban. */
  banType?:
    | LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType
    | undefined;
  /**
   * The duration of the ban. This property is only present if the
   * <code>banType</code> is <code>temporary</code>.
   */
  banDurationSeconds?: number | undefined;
}

export type LiveChatUserBannedMessageDetails_BanTypeWrapper = {}

export enum LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType {
  PERMANENT = 1,
  TEMPORARY = 2,
  UNRECOGNIZED = -1,
}

export function liveChatUserBannedMessageDetails_BanTypeWrapper_BanTypeFromJSON(
  object: any,
): LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType {
  switch (object) {
    case 1:
    case "PERMANENT":
      return LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.PERMANENT;
    case 2:
    case "TEMPORARY":
      return LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.TEMPORARY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.UNRECOGNIZED;
  }
}

export function liveChatUserBannedMessageDetails_BanTypeWrapper_BanTypeToJSON(
  object: LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType,
): string {
  switch (object) {
    case LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.PERMANENT:
      return "PERMANENT";
    case LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.TEMPORARY:
      return "TEMPORARY";
    case LiveChatUserBannedMessageDetails_BanTypeWrapper_BanType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LiveChatSuperChatDetails {
  /** The amount purchased by the user, in micros (1,750,000 micros = 1.75). */
  amountMicros?:
    | number
    | undefined;
  /** The currency in which the purchase was made. */
  currency?:
    | string
    | undefined;
  /** A rendered string that displays the fund amount and currency to the user. */
  amountDisplayString?:
    | string
    | undefined;
  /** The comment added by the user to this Super Chat event. */
  userComment?:
    | string
    | undefined;
  /**
   * The tier in which the amount belongs. Lower amounts belong to lower
   * tiers. The lowest tier is <code>1</code>.
   */
  tier?: number | undefined;
}

export interface LiveChatSuperStickerDetails {
  /** The amount purchased by the user, in micros (1,750,000 micros = 1.75). */
  amountMicros?:
    | number
    | undefined;
  /** The currency in which the purchase was made. */
  currency?:
    | string
    | undefined;
  /** A rendered string that displays the fund amount and currency to the user. */
  amountDisplayString?:
    | string
    | undefined;
  /**
   * The tier in which the amount belongs. Lower amounts belong to lower
   * tiers. The lowest tier is <code>1</code>.
   */
  tier?:
    | number
    | undefined;
  /** Information about the Super Sticker. */
  superStickerMetadata?: SuperStickerMetadata | undefined;
}

export interface LiveChatFanFundingEventDetails {
  /** The amount of the fund. */
  amountMicros?:
    | number
    | undefined;
  /** The currency in which the fund was made. */
  currency?:
    | string
    | undefined;
  /** A rendered string that displays the fund amount and currency to the user. */
  amountDisplayString?:
    | string
    | undefined;
  /** The comment added by the user to this fan funding event. */
  userComment?: string | undefined;
}

export interface LiveChatNewSponsorDetails {
  /**
   * The name of the Level that the viewer just had joined. The Level names
   * are defined by the YouTube channel offering the Membership.
   *
   * In some situations this field isn't filled.
   */
  memberLevelName?:
    | string
    | undefined;
  /**
   * If the viewer just had upgraded from a lower level. For viewers that
   * were not members at the time of purchase, this field is false.
   */
  isUpgrade?: boolean | undefined;
}

export interface LiveChatMemberMilestoneChatDetails {
  /**
   * The name of the Level at which the viever is a member. The Level names
   * are defined by the YouTube channel offering the Membership.
   *
   * In some situations this field isn't filled.
   */
  memberLevelName?:
    | string
    | undefined;
  /**
   * The total amount of months (rounded up) the viewer has been a member
   * that granted them this Member Milestone Chat. This is the same
   * number of months as is being displayed to YouTube users.
   */
  memberMonth?:
    | number
    | undefined;
  /**
   * The comment added by the member to this Member Milestone Chat.
   *
   * This field is empty for messages without a comment from the member.
   */
  userComment?: string | undefined;
}

export interface LiveChatMembershipGiftingDetails {
  /** The number of gift memberships purchased by the user. */
  giftMembershipsCount?:
    | number
    | undefined;
  /**
   * The name of the level of the gift memberships purchased by the user. The
   * Level names are defined by the YouTube channel offering the Membership.
   *
   * In some situations this field isn't filled.
   */
  giftMembershipsLevelName?: string | undefined;
}

export interface LiveChatGiftMembershipReceivedDetails {
  /**
   * The name of the Level at which the viewer is a member. This matches the
   * `snippet.membershipGiftingDetails.giftMembershipsLevelName` of the
   * associated membership gifting message. The Level names are defined by the
   * YouTube channel offering the Membership.
   *
   * In some situations this field isn't filled.
   */
  memberLevelName?:
    | string
    | undefined;
  /**
   * The ID of the user that made the membership gifting purchase. This matches
   * the `snippet.authorChannelId` of the associated membership gifting message.
   */
  gifterChannelId?:
    | string
    | undefined;
  /**
   * The ID of the membership gifting message that is related to this gift
   * membership. This ID will always refer to a message whose type is
   * 'membershipGiftingEvent'.
   */
  associatedMembershipGiftingMessageId?: string | undefined;
}

export interface LiveChatPollDetails {
  metadata?: LiveChatPollDetails_PollMetadata | undefined;
  status?: LiveChatPollDetails_PollStatusWrapper_PollStatus | undefined;
}

export interface LiveChatPollDetails_PollMetadata {
  questionText?:
    | string
    | undefined;
  /** The options will be returned in the order that is displayed in 1P */
  options: LiveChatPollDetails_PollMetadata_PollOption[];
}

export interface LiveChatPollDetails_PollMetadata_PollOption {
  optionText?: string | undefined;
  tally?: number | undefined;
}

/** Current point in the polls lifecycle. */
export type LiveChatPollDetails_PollStatusWrapper = {}

export enum LiveChatPollDetails_PollStatusWrapper_PollStatus {
  UNKNOWN = 0,
  ACTIVE = 1,
  CLOSED = 2,
  UNRECOGNIZED = -1,
}

export function liveChatPollDetails_PollStatusWrapper_PollStatusFromJSON(
  object: any,
): LiveChatPollDetails_PollStatusWrapper_PollStatus {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return LiveChatPollDetails_PollStatusWrapper_PollStatus.UNKNOWN;
    case 1:
    case "ACTIVE":
      return LiveChatPollDetails_PollStatusWrapper_PollStatus.ACTIVE;
    case 2:
    case "CLOSED":
      return LiveChatPollDetails_PollStatusWrapper_PollStatus.CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LiveChatPollDetails_PollStatusWrapper_PollStatus.UNRECOGNIZED;
  }
}

export function liveChatPollDetails_PollStatusWrapper_PollStatusToJSON(
  object: LiveChatPollDetails_PollStatusWrapper_PollStatus,
): string {
  switch (object) {
    case LiveChatPollDetails_PollStatusWrapper_PollStatus.UNKNOWN:
      return "UNKNOWN";
    case LiveChatPollDetails_PollStatusWrapper_PollStatus.ACTIVE:
      return "ACTIVE";
    case LiveChatPollDetails_PollStatusWrapper_PollStatus.CLOSED:
      return "CLOSED";
    case LiveChatPollDetails_PollStatusWrapper_PollStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SuperChatEventSnippet {
  /** Channel ID where the event occurred. */
  channelId?:
    | string
    | undefined;
  /** Details about the supporter. */
  supporterDetails?:
    | ChannelProfileDetails
    | undefined;
  /** The text contents of the comment left by the user. */
  commentText?:
    | string
    | undefined;
  /**
   * The date and time when the event occurred. The value is
   * specified in <a href="//www.w3.org/TR/NOTE-datetime">ISO 8601</a>
   * format.
   */
  createdAt?:
    | string
    | undefined;
  /**
   * The purchase amount, in micros of the purchase currency.  For example, 1 is
   * represented as 1000000.
   */
  amountMicros?:
    | number
    | undefined;
  /** The currency in which the purchase was made.  ISO 4217. */
  currency?:
    | string
    | undefined;
  /**
   * A rendered string that displays the purchase amount and currency
   * (e.g., "$1.00").  The string is rendered for the given language.
   */
  displayString?:
    | string
    | undefined;
  /**
   * The tier for the paid message, which is based on the amount of money spent
   * to purchase the message.
   */
  messageType?:
    | number
    | undefined;
  /** True if this event is a Super Sticker event. */
  isSuperStickerEvent?:
    | boolean
    | undefined;
  /**
   * If this event is a Super Sticker event, this field will contain metadata
   * about the Super Sticker.
   */
  superStickerMetadata?: SuperStickerMetadata | undefined;
}

export interface SuperStickerMetadata {
  /**
   * Unique identifier of the Super Sticker. This is a shorter form of the
   * alt_text that includes pack name and a recognizable characteristic of the
   * sticker.
   */
  stickerId?:
    | string
    | undefined;
  /**
   * Internationalized alt text that describes the sticker image and any
   * animation associated with it.
   */
  altText?:
    | string
    | undefined;
  /** Specifies the localization language in which the alt text is returned. */
  altTextLanguage?: string | undefined;
}

export interface ChannelProfileDetails {
  /** The YouTube channel ID. */
  channelId?:
    | string
    | undefined;
  /** The channel's URL. */
  channelUrl?:
    | string
    | undefined;
  /** The channel's display name. */
  displayName?:
    | string
    | undefined;
  /** The channels's avatar URL. */
  profileImageUrl?: string | undefined;
}

/**
 * Paging details for lists of resources, including total number of items
 * available and number of resources returned in a single page.
 */
export interface PageInfo {
  /** The total number of results in the result set. */
  totalResults?:
    | number
    | undefined;
  /** The number of results included in the API response. */
  resultsPerPage?: number | undefined;
}

function createBaseLiveChatMessageListRequest(): LiveChatMessageListRequest {
  return { liveChatId: "", hl: "", profileImageSize: 0, maxResults: 0, pageToken: "", part: [] };
}

export const LiveChatMessageListRequest: MessageFns<LiveChatMessageListRequest> = {
  encode(message: LiveChatMessageListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.liveChatId !== undefined && message.liveChatId !== "") {
      writer.uint32(10).string(message.liveChatId);
    }
    if (message.hl !== undefined && message.hl !== "") {
      writer.uint32(18).string(message.hl);
    }
    if (message.profileImageSize !== undefined && message.profileImageSize !== 0) {
      writer.uint32(24).uint32(message.profileImageSize);
    }
    if (message.maxResults !== undefined && message.maxResults !== 0) {
      writer.uint32(784).uint32(message.maxResults);
    }
    if (message.pageToken !== undefined && message.pageToken !== "") {
      writer.uint32(794).string(message.pageToken);
    }
    for (const v of message.part) {
      writer.uint32(802).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.liveChatId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.profileImageSize = reader.uint32();
          continue;
        }
        case 98: {
          if (tag !== 784) {
            break;
          }

          message.maxResults = reader.uint32();
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.part.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageListRequest {
    return {
      liveChatId: isSet(object.liveChatId) ? globalThis.String(object.liveChatId) : "",
      hl: isSet(object.hl) ? globalThis.String(object.hl) : "",
      profileImageSize: isSet(object.profileImageSize) ? globalThis.Number(object.profileImageSize) : 0,
      maxResults: isSet(object.maxResults) ? globalThis.Number(object.maxResults) : 0,
      pageToken: isSet(object.pageToken) ? globalThis.String(object.pageToken) : "",
      part: globalThis.Array.isArray(object?.part) ? object.part.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: LiveChatMessageListRequest): unknown {
    const obj: any = {};
    if (message.liveChatId !== undefined && message.liveChatId !== "") {
      obj.liveChatId = message.liveChatId;
    }
    if (message.hl !== undefined && message.hl !== "") {
      obj.hl = message.hl;
    }
    if (message.profileImageSize !== undefined && message.profileImageSize !== 0) {
      obj.profileImageSize = Math.round(message.profileImageSize);
    }
    if (message.maxResults !== undefined && message.maxResults !== 0) {
      obj.maxResults = Math.round(message.maxResults);
    }
    if (message.pageToken !== undefined && message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.part?.length) {
      obj.part = message.part;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageListRequest>, I>>(base?: I): LiveChatMessageListRequest {
    return LiveChatMessageListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageListRequest>, I>>(object: I): LiveChatMessageListRequest {
    const message = createBaseLiveChatMessageListRequest();
    message.liveChatId = object.liveChatId ?? "";
    message.hl = object.hl ?? "";
    message.profileImageSize = object.profileImageSize ?? 0;
    message.maxResults = object.maxResults ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.part = object.part?.map((e) => e) || [];
    return message;
  },
};

function createBaseLiveChatMessageListResponse(): LiveChatMessageListResponse {
  return {
    kind: "",
    etag: "",
    offlineAt: "",
    pageInfo: undefined,
    nextPageToken: "",
    items: [],
    activePollItem: undefined,
  };
}

export const LiveChatMessageListResponse: MessageFns<LiveChatMessageListResponse> = {
  encode(message: LiveChatMessageListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== undefined && message.kind !== "") {
      writer.uint32(1602).string(message.kind);
    }
    if (message.etag !== undefined && message.etag !== "") {
      writer.uint32(1610).string(message.etag);
    }
    if (message.offlineAt !== undefined && message.offlineAt !== "") {
      writer.uint32(18).string(message.offlineAt);
    }
    if (message.pageInfo !== undefined) {
      PageInfo.encode(message.pageInfo, writer.uint32(8034).fork()).join();
    }
    if (message.nextPageToken !== undefined && message.nextPageToken !== "") {
      writer.uint32(804818).string(message.nextPageToken);
    }
    for (const v of message.items) {
      LiveChatMessage.encode(v!, writer.uint32(8058).fork()).join();
    }
    if (message.activePollItem !== undefined) {
      LiveChatMessage.encode(message.activePollItem, writer.uint32(8066).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 200: {
          if (tag !== 1602) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 201: {
          if (tag !== 1610) {
            break;
          }

          message.etag = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.offlineAt = reader.string();
          continue;
        }
        case 1004: {
          if (tag !== 8034) {
            break;
          }

          message.pageInfo = PageInfo.decode(reader, reader.uint32());
          continue;
        }
        case 100602: {
          if (tag !== 804818) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 1007: {
          if (tag !== 8058) {
            break;
          }

          message.items.push(LiveChatMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 1008: {
          if (tag !== 8066) {
            break;
          }

          message.activePollItem = LiveChatMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageListResponse {
    return {
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      etag: isSet(object.etag) ? globalThis.String(object.etag) : "",
      offlineAt: isSet(object.offlineAt) ? globalThis.String(object.offlineAt) : "",
      pageInfo: isSet(object.pageInfo) ? PageInfo.fromJSON(object.pageInfo) : undefined,
      nextPageToken: isSet(object.nextPageToken) ? globalThis.String(object.nextPageToken) : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => LiveChatMessage.fromJSON(e)) : [],
      activePollItem: isSet(object.activePollItem) ? LiveChatMessage.fromJSON(object.activePollItem) : undefined,
    };
  },

  toJSON(message: LiveChatMessageListResponse): unknown {
    const obj: any = {};
    if (message.kind !== undefined && message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.etag !== undefined && message.etag !== "") {
      obj.etag = message.etag;
    }
    if (message.offlineAt !== undefined && message.offlineAt !== "") {
      obj.offlineAt = message.offlineAt;
    }
    if (message.pageInfo !== undefined) {
      obj.pageInfo = PageInfo.toJSON(message.pageInfo);
    }
    if (message.nextPageToken !== undefined && message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => LiveChatMessage.toJSON(e));
    }
    if (message.activePollItem !== undefined) {
      obj.activePollItem = LiveChatMessage.toJSON(message.activePollItem);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageListResponse>, I>>(base?: I): LiveChatMessageListResponse {
    return LiveChatMessageListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageListResponse>, I>>(object: I): LiveChatMessageListResponse {
    const message = createBaseLiveChatMessageListResponse();
    message.kind = object.kind ?? "";
    message.etag = object.etag ?? "";
    message.offlineAt = object.offlineAt ?? "";
    message.pageInfo = (object.pageInfo !== undefined && object.pageInfo !== null)
      ? PageInfo.fromPartial(object.pageInfo)
      : undefined;
    message.nextPageToken = object.nextPageToken ?? "";
    message.items = object.items?.map((e) => LiveChatMessage.fromPartial(e)) || [];
    message.activePollItem = (object.activePollItem !== undefined && object.activePollItem !== null)
      ? LiveChatMessage.fromPartial(object.activePollItem)
      : undefined;
    return message;
  },
};

function createBaseLiveChatMessage(): LiveChatMessage {
  return { kind: "", etag: "", id: "", snippet: undefined, authorDetails: undefined };
}

export const LiveChatMessage: MessageFns<LiveChatMessage> = {
  encode(message: LiveChatMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== undefined && message.kind !== "") {
      writer.uint32(1602).string(message.kind);
    }
    if (message.etag !== undefined && message.etag !== "") {
      writer.uint32(1610).string(message.etag);
    }
    if (message.id !== undefined && message.id !== "") {
      writer.uint32(810).string(message.id);
    }
    if (message.snippet !== undefined) {
      LiveChatMessageSnippet.encode(message.snippet, writer.uint32(18).fork()).join();
    }
    if (message.authorDetails !== undefined) {
      LiveChatMessageAuthorDetails.encode(message.authorDetails, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 200: {
          if (tag !== 1602) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 201: {
          if (tag !== 1610) {
            break;
          }

          message.etag = reader.string();
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.snippet = LiveChatMessageSnippet.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.authorDetails = LiveChatMessageAuthorDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessage {
    return {
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      etag: isSet(object.etag) ? globalThis.String(object.etag) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      snippet: isSet(object.snippet) ? LiveChatMessageSnippet.fromJSON(object.snippet) : undefined,
      authorDetails: isSet(object.authorDetails)
        ? LiveChatMessageAuthorDetails.fromJSON(object.authorDetails)
        : undefined,
    };
  },

  toJSON(message: LiveChatMessage): unknown {
    const obj: any = {};
    if (message.kind !== undefined && message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.etag !== undefined && message.etag !== "") {
      obj.etag = message.etag;
    }
    if (message.id !== undefined && message.id !== "") {
      obj.id = message.id;
    }
    if (message.snippet !== undefined) {
      obj.snippet = LiveChatMessageSnippet.toJSON(message.snippet);
    }
    if (message.authorDetails !== undefined) {
      obj.authorDetails = LiveChatMessageAuthorDetails.toJSON(message.authorDetails);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessage>, I>>(base?: I): LiveChatMessage {
    return LiveChatMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessage>, I>>(object: I): LiveChatMessage {
    const message = createBaseLiveChatMessage();
    message.kind = object.kind ?? "";
    message.etag = object.etag ?? "";
    message.id = object.id ?? "";
    message.snippet = (object.snippet !== undefined && object.snippet !== null)
      ? LiveChatMessageSnippet.fromPartial(object.snippet)
      : undefined;
    message.authorDetails = (object.authorDetails !== undefined && object.authorDetails !== null)
      ? LiveChatMessageAuthorDetails.fromPartial(object.authorDetails)
      : undefined;
    return message;
  },
};

function createBaseLiveChatMessageAuthorDetails(): LiveChatMessageAuthorDetails {
  return {
    channelId: "",
    channelUrl: "",
    displayName: "",
    profileImageUrl: "",
    isVerified: false,
    isChatOwner: false,
    isChatSponsor: false,
    isChatModerator: false,
  };
}

export const LiveChatMessageAuthorDetails: MessageFns<LiveChatMessageAuthorDetails> = {
  encode(message: LiveChatMessageAuthorDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelId !== undefined && message.channelId !== "") {
      writer.uint32(80810).string(message.channelId);
    }
    if (message.channelUrl !== undefined && message.channelUrl !== "") {
      writer.uint32(818).string(message.channelUrl);
    }
    if (message.displayName !== undefined && message.displayName !== "") {
      writer.uint32(826).string(message.displayName);
    }
    if (message.profileImageUrl !== undefined && message.profileImageUrl !== "") {
      writer.uint32(834).string(message.profileImageUrl);
    }
    if (message.isVerified !== undefined && message.isVerified !== false) {
      writer.uint32(32).bool(message.isVerified);
    }
    if (message.isChatOwner !== undefined && message.isChatOwner !== false) {
      writer.uint32(40).bool(message.isChatOwner);
    }
    if (message.isChatSponsor !== undefined && message.isChatSponsor !== false) {
      writer.uint32(48).bool(message.isChatSponsor);
    }
    if (message.isChatModerator !== undefined && message.isChatModerator !== false) {
      writer.uint32(56).bool(message.isChatModerator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageAuthorDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageAuthorDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 10101: {
          if (tag !== 80810) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.channelUrl = reader.string();
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.profileImageUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isVerified = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isChatOwner = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isChatSponsor = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isChatModerator = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageAuthorDetails {
    return {
      channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
      channelUrl: isSet(object.channelUrl) ? globalThis.String(object.channelUrl) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      profileImageUrl: isSet(object.profileImageUrl) ? globalThis.String(object.profileImageUrl) : "",
      isVerified: isSet(object.isVerified) ? globalThis.Boolean(object.isVerified) : false,
      isChatOwner: isSet(object.isChatOwner) ? globalThis.Boolean(object.isChatOwner) : false,
      isChatSponsor: isSet(object.isChatSponsor) ? globalThis.Boolean(object.isChatSponsor) : false,
      isChatModerator: isSet(object.isChatModerator) ? globalThis.Boolean(object.isChatModerator) : false,
    };
  },

  toJSON(message: LiveChatMessageAuthorDetails): unknown {
    const obj: any = {};
    if (message.channelId !== undefined && message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.channelUrl !== undefined && message.channelUrl !== "") {
      obj.channelUrl = message.channelUrl;
    }
    if (message.displayName !== undefined && message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.profileImageUrl !== undefined && message.profileImageUrl !== "") {
      obj.profileImageUrl = message.profileImageUrl;
    }
    if (message.isVerified !== undefined && message.isVerified !== false) {
      obj.isVerified = message.isVerified;
    }
    if (message.isChatOwner !== undefined && message.isChatOwner !== false) {
      obj.isChatOwner = message.isChatOwner;
    }
    if (message.isChatSponsor !== undefined && message.isChatSponsor !== false) {
      obj.isChatSponsor = message.isChatSponsor;
    }
    if (message.isChatModerator !== undefined && message.isChatModerator !== false) {
      obj.isChatModerator = message.isChatModerator;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageAuthorDetails>, I>>(base?: I): LiveChatMessageAuthorDetails {
    return LiveChatMessageAuthorDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageAuthorDetails>, I>>(object: I): LiveChatMessageAuthorDetails {
    const message = createBaseLiveChatMessageAuthorDetails();
    message.channelId = object.channelId ?? "";
    message.channelUrl = object.channelUrl ?? "";
    message.displayName = object.displayName ?? "";
    message.profileImageUrl = object.profileImageUrl ?? "";
    message.isVerified = object.isVerified ?? false;
    message.isChatOwner = object.isChatOwner ?? false;
    message.isChatSponsor = object.isChatSponsor ?? false;
    message.isChatModerator = object.isChatModerator ?? false;
    return message;
  },
};

function createBaseLiveChatMessageSnippet(): LiveChatMessageSnippet {
  return {
    type: 0,
    liveChatId: "",
    authorChannelId: "",
    publishedAt: "",
    hasDisplayContent: false,
    displayMessage: "",
    textMessageDetails: undefined,
    messageDeletedDetails: undefined,
    messageRetractedDetails: undefined,
    userBannedDetails: undefined,
    superChatDetails: undefined,
    superStickerDetails: undefined,
    newSponsorDetails: undefined,
    memberMilestoneChatDetails: undefined,
    membershipGiftingDetails: undefined,
    giftMembershipReceivedDetails: undefined,
    pollDetails: undefined,
  };
}

export const LiveChatMessageSnippet: MessageFns<LiveChatMessageSnippet> = {
  encode(message: LiveChatMessageSnippet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined && message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.liveChatId !== undefined && message.liveChatId !== "") {
      writer.uint32(1610).string(message.liveChatId);
    }
    if (message.authorChannelId !== undefined && message.authorChannelId !== "") {
      writer.uint32(2410).string(message.authorChannelId);
    }
    if (message.publishedAt !== undefined && message.publishedAt !== "") {
      writer.uint32(34).string(message.publishedAt);
    }
    if (message.hasDisplayContent !== undefined && message.hasDisplayContent !== false) {
      writer.uint32(136).bool(message.hasDisplayContent);
    }
    if (message.displayMessage !== undefined && message.displayMessage !== "") {
      writer.uint32(130).string(message.displayMessage);
    }
    if (message.textMessageDetails !== undefined) {
      LiveChatTextMessageDetails.encode(message.textMessageDetails, writer.uint32(154).fork()).join();
    }
    if (message.messageDeletedDetails !== undefined) {
      LiveChatMessageDeletedDetails.encode(message.messageDeletedDetails, writer.uint32(162).fork()).join();
    }
    if (message.messageRetractedDetails !== undefined) {
      LiveChatMessageRetractedDetails.encode(message.messageRetractedDetails, writer.uint32(170).fork()).join();
    }
    if (message.userBannedDetails !== undefined) {
      LiveChatUserBannedMessageDetails.encode(message.userBannedDetails, writer.uint32(178).fork()).join();
    }
    if (message.superChatDetails !== undefined) {
      LiveChatSuperChatDetails.encode(message.superChatDetails, writer.uint32(218).fork()).join();
    }
    if (message.superStickerDetails !== undefined) {
      LiveChatSuperStickerDetails.encode(message.superStickerDetails, writer.uint32(226).fork()).join();
    }
    if (message.newSponsorDetails !== undefined) {
      LiveChatNewSponsorDetails.encode(message.newSponsorDetails, writer.uint32(234).fork()).join();
    }
    if (message.memberMilestoneChatDetails !== undefined) {
      LiveChatMemberMilestoneChatDetails.encode(message.memberMilestoneChatDetails, writer.uint32(242).fork()).join();
    }
    if (message.membershipGiftingDetails !== undefined) {
      LiveChatMembershipGiftingDetails.encode(message.membershipGiftingDetails, writer.uint32(250).fork()).join();
    }
    if (message.giftMembershipReceivedDetails !== undefined) {
      LiveChatGiftMembershipReceivedDetails.encode(message.giftMembershipReceivedDetails, writer.uint32(258).fork())
        .join();
    }
    if (message.pollDetails !== undefined) {
      LiveChatPollDetails.encode(message.pollDetails, writer.uint32(266).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageSnippet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageSnippet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 201: {
          if (tag !== 1610) {
            break;
          }

          message.liveChatId = reader.string();
          continue;
        }
        case 301: {
          if (tag !== 2410) {
            break;
          }

          message.authorChannelId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.publishedAt = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.hasDisplayContent = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.displayMessage = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.textMessageDetails = LiveChatTextMessageDetails.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.messageDeletedDetails = LiveChatMessageDeletedDetails.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.messageRetractedDetails = LiveChatMessageRetractedDetails.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.userBannedDetails = LiveChatUserBannedMessageDetails.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.superChatDetails = LiveChatSuperChatDetails.decode(reader, reader.uint32());
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.superStickerDetails = LiveChatSuperStickerDetails.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.newSponsorDetails = LiveChatNewSponsorDetails.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.memberMilestoneChatDetails = LiveChatMemberMilestoneChatDetails.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.membershipGiftingDetails = LiveChatMembershipGiftingDetails.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.giftMembershipReceivedDetails = LiveChatGiftMembershipReceivedDetails.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.pollDetails = LiveChatPollDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageSnippet {
    return {
      type: isSet(object.type) ? liveChatMessageSnippet_TypeWrapper_TypeFromJSON(object.type) : 0,
      liveChatId: isSet(object.liveChatId) ? globalThis.String(object.liveChatId) : "",
      authorChannelId: isSet(object.authorChannelId) ? globalThis.String(object.authorChannelId) : "",
      publishedAt: isSet(object.publishedAt) ? globalThis.String(object.publishedAt) : "",
      hasDisplayContent: isSet(object.hasDisplayContent) ? globalThis.Boolean(object.hasDisplayContent) : false,
      displayMessage: isSet(object.displayMessage) ? globalThis.String(object.displayMessage) : "",
      textMessageDetails: isSet(object.textMessageDetails)
        ? LiveChatTextMessageDetails.fromJSON(object.textMessageDetails)
        : undefined,
      messageDeletedDetails: isSet(object.messageDeletedDetails)
        ? LiveChatMessageDeletedDetails.fromJSON(object.messageDeletedDetails)
        : undefined,
      messageRetractedDetails: isSet(object.messageRetractedDetails)
        ? LiveChatMessageRetractedDetails.fromJSON(object.messageRetractedDetails)
        : undefined,
      userBannedDetails: isSet(object.userBannedDetails)
        ? LiveChatUserBannedMessageDetails.fromJSON(object.userBannedDetails)
        : undefined,
      superChatDetails: isSet(object.superChatDetails)
        ? LiveChatSuperChatDetails.fromJSON(object.superChatDetails)
        : undefined,
      superStickerDetails: isSet(object.superStickerDetails)
        ? LiveChatSuperStickerDetails.fromJSON(object.superStickerDetails)
        : undefined,
      newSponsorDetails: isSet(object.newSponsorDetails)
        ? LiveChatNewSponsorDetails.fromJSON(object.newSponsorDetails)
        : undefined,
      memberMilestoneChatDetails: isSet(object.memberMilestoneChatDetails)
        ? LiveChatMemberMilestoneChatDetails.fromJSON(object.memberMilestoneChatDetails)
        : undefined,
      membershipGiftingDetails: isSet(object.membershipGiftingDetails)
        ? LiveChatMembershipGiftingDetails.fromJSON(object.membershipGiftingDetails)
        : undefined,
      giftMembershipReceivedDetails: isSet(object.giftMembershipReceivedDetails)
        ? LiveChatGiftMembershipReceivedDetails.fromJSON(object.giftMembershipReceivedDetails)
        : undefined,
      pollDetails: isSet(object.pollDetails) ? LiveChatPollDetails.fromJSON(object.pollDetails) : undefined,
    };
  },

  toJSON(message: LiveChatMessageSnippet): unknown {
    const obj: any = {};
    if (message.type !== undefined && message.type !== 0) {
      obj.type = liveChatMessageSnippet_TypeWrapper_TypeToJSON(message.type);
    }
    if (message.liveChatId !== undefined && message.liveChatId !== "") {
      obj.liveChatId = message.liveChatId;
    }
    if (message.authorChannelId !== undefined && message.authorChannelId !== "") {
      obj.authorChannelId = message.authorChannelId;
    }
    if (message.publishedAt !== undefined && message.publishedAt !== "") {
      obj.publishedAt = message.publishedAt;
    }
    if (message.hasDisplayContent !== undefined && message.hasDisplayContent !== false) {
      obj.hasDisplayContent = message.hasDisplayContent;
    }
    if (message.displayMessage !== undefined && message.displayMessage !== "") {
      obj.displayMessage = message.displayMessage;
    }
    if (message.textMessageDetails !== undefined) {
      obj.textMessageDetails = LiveChatTextMessageDetails.toJSON(message.textMessageDetails);
    }
    if (message.messageDeletedDetails !== undefined) {
      obj.messageDeletedDetails = LiveChatMessageDeletedDetails.toJSON(message.messageDeletedDetails);
    }
    if (message.messageRetractedDetails !== undefined) {
      obj.messageRetractedDetails = LiveChatMessageRetractedDetails.toJSON(message.messageRetractedDetails);
    }
    if (message.userBannedDetails !== undefined) {
      obj.userBannedDetails = LiveChatUserBannedMessageDetails.toJSON(message.userBannedDetails);
    }
    if (message.superChatDetails !== undefined) {
      obj.superChatDetails = LiveChatSuperChatDetails.toJSON(message.superChatDetails);
    }
    if (message.superStickerDetails !== undefined) {
      obj.superStickerDetails = LiveChatSuperStickerDetails.toJSON(message.superStickerDetails);
    }
    if (message.newSponsorDetails !== undefined) {
      obj.newSponsorDetails = LiveChatNewSponsorDetails.toJSON(message.newSponsorDetails);
    }
    if (message.memberMilestoneChatDetails !== undefined) {
      obj.memberMilestoneChatDetails = LiveChatMemberMilestoneChatDetails.toJSON(message.memberMilestoneChatDetails);
    }
    if (message.membershipGiftingDetails !== undefined) {
      obj.membershipGiftingDetails = LiveChatMembershipGiftingDetails.toJSON(message.membershipGiftingDetails);
    }
    if (message.giftMembershipReceivedDetails !== undefined) {
      obj.giftMembershipReceivedDetails = LiveChatGiftMembershipReceivedDetails.toJSON(
        message.giftMembershipReceivedDetails,
      );
    }
    if (message.pollDetails !== undefined) {
      obj.pollDetails = LiveChatPollDetails.toJSON(message.pollDetails);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageSnippet>, I>>(base?: I): LiveChatMessageSnippet {
    return LiveChatMessageSnippet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageSnippet>, I>>(object: I): LiveChatMessageSnippet {
    const message = createBaseLiveChatMessageSnippet();
    message.type = object.type ?? 0;
    message.liveChatId = object.liveChatId ?? "";
    message.authorChannelId = object.authorChannelId ?? "";
    message.publishedAt = object.publishedAt ?? "";
    message.hasDisplayContent = object.hasDisplayContent ?? false;
    message.displayMessage = object.displayMessage ?? "";
    message.textMessageDetails = (object.textMessageDetails !== undefined && object.textMessageDetails !== null)
      ? LiveChatTextMessageDetails.fromPartial(object.textMessageDetails)
      : undefined;
    message.messageDeletedDetails =
      (object.messageDeletedDetails !== undefined && object.messageDeletedDetails !== null)
        ? LiveChatMessageDeletedDetails.fromPartial(object.messageDeletedDetails)
        : undefined;
    message.messageRetractedDetails =
      (object.messageRetractedDetails !== undefined && object.messageRetractedDetails !== null)
        ? LiveChatMessageRetractedDetails.fromPartial(object.messageRetractedDetails)
        : undefined;
    message.userBannedDetails = (object.userBannedDetails !== undefined && object.userBannedDetails !== null)
      ? LiveChatUserBannedMessageDetails.fromPartial(object.userBannedDetails)
      : undefined;
    message.superChatDetails = (object.superChatDetails !== undefined && object.superChatDetails !== null)
      ? LiveChatSuperChatDetails.fromPartial(object.superChatDetails)
      : undefined;
    message.superStickerDetails = (object.superStickerDetails !== undefined && object.superStickerDetails !== null)
      ? LiveChatSuperStickerDetails.fromPartial(object.superStickerDetails)
      : undefined;
    message.newSponsorDetails = (object.newSponsorDetails !== undefined && object.newSponsorDetails !== null)
      ? LiveChatNewSponsorDetails.fromPartial(object.newSponsorDetails)
      : undefined;
    message.memberMilestoneChatDetails =
      (object.memberMilestoneChatDetails !== undefined && object.memberMilestoneChatDetails !== null)
        ? LiveChatMemberMilestoneChatDetails.fromPartial(object.memberMilestoneChatDetails)
        : undefined;
    message.membershipGiftingDetails =
      (object.membershipGiftingDetails !== undefined && object.membershipGiftingDetails !== null)
        ? LiveChatMembershipGiftingDetails.fromPartial(object.membershipGiftingDetails)
        : undefined;
    message.giftMembershipReceivedDetails =
      (object.giftMembershipReceivedDetails !== undefined && object.giftMembershipReceivedDetails !== null)
        ? LiveChatGiftMembershipReceivedDetails.fromPartial(object.giftMembershipReceivedDetails)
        : undefined;
    message.pollDetails = (object.pollDetails !== undefined && object.pollDetails !== null)
      ? LiveChatPollDetails.fromPartial(object.pollDetails)
      : undefined;
    return message;
  },
};

function createBaseLiveChatMessageSnippet_TypeWrapper(): LiveChatMessageSnippet_TypeWrapper {
  return {};
}

export const LiveChatMessageSnippet_TypeWrapper: MessageFns<LiveChatMessageSnippet_TypeWrapper> = {
  encode(_: LiveChatMessageSnippet_TypeWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageSnippet_TypeWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageSnippet_TypeWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LiveChatMessageSnippet_TypeWrapper {
    return {};
  },

  toJSON(_: LiveChatMessageSnippet_TypeWrapper): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageSnippet_TypeWrapper>, I>>(
    base?: I,
  ): LiveChatMessageSnippet_TypeWrapper {
    return LiveChatMessageSnippet_TypeWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageSnippet_TypeWrapper>, I>>(
    _: I,
  ): LiveChatMessageSnippet_TypeWrapper {
    const message = createBaseLiveChatMessageSnippet_TypeWrapper();
    return message;
  },
};

function createBaseLiveChatTextMessageDetails(): LiveChatTextMessageDetails {
  return { messageText: "" };
}

export const LiveChatTextMessageDetails: MessageFns<LiveChatTextMessageDetails> = {
  encode(message: LiveChatTextMessageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageText !== undefined && message.messageText !== "") {
      writer.uint32(10).string(message.messageText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatTextMessageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatTextMessageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatTextMessageDetails {
    return { messageText: isSet(object.messageText) ? globalThis.String(object.messageText) : "" };
  },

  toJSON(message: LiveChatTextMessageDetails): unknown {
    const obj: any = {};
    if (message.messageText !== undefined && message.messageText !== "") {
      obj.messageText = message.messageText;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatTextMessageDetails>, I>>(base?: I): LiveChatTextMessageDetails {
    return LiveChatTextMessageDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatTextMessageDetails>, I>>(object: I): LiveChatTextMessageDetails {
    const message = createBaseLiveChatTextMessageDetails();
    message.messageText = object.messageText ?? "";
    return message;
  },
};

function createBaseLiveChatMessageDeletedDetails(): LiveChatMessageDeletedDetails {
  return { deletedMessageId: "" };
}

export const LiveChatMessageDeletedDetails: MessageFns<LiveChatMessageDeletedDetails> = {
  encode(message: LiveChatMessageDeletedDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deletedMessageId !== undefined && message.deletedMessageId !== "") {
      writer.uint32(810).string(message.deletedMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageDeletedDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageDeletedDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.deletedMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageDeletedDetails {
    return { deletedMessageId: isSet(object.deletedMessageId) ? globalThis.String(object.deletedMessageId) : "" };
  },

  toJSON(message: LiveChatMessageDeletedDetails): unknown {
    const obj: any = {};
    if (message.deletedMessageId !== undefined && message.deletedMessageId !== "") {
      obj.deletedMessageId = message.deletedMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageDeletedDetails>, I>>(base?: I): LiveChatMessageDeletedDetails {
    return LiveChatMessageDeletedDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageDeletedDetails>, I>>(
    object: I,
  ): LiveChatMessageDeletedDetails {
    const message = createBaseLiveChatMessageDeletedDetails();
    message.deletedMessageId = object.deletedMessageId ?? "";
    return message;
  },
};

function createBaseLiveChatMessageRetractedDetails(): LiveChatMessageRetractedDetails {
  return { retractedMessageId: "" };
}

export const LiveChatMessageRetractedDetails: MessageFns<LiveChatMessageRetractedDetails> = {
  encode(message: LiveChatMessageRetractedDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.retractedMessageId !== undefined && message.retractedMessageId !== "") {
      writer.uint32(1610).string(message.retractedMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMessageRetractedDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMessageRetractedDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 201: {
          if (tag !== 1610) {
            break;
          }

          message.retractedMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMessageRetractedDetails {
    return { retractedMessageId: isSet(object.retractedMessageId) ? globalThis.String(object.retractedMessageId) : "" };
  },

  toJSON(message: LiveChatMessageRetractedDetails): unknown {
    const obj: any = {};
    if (message.retractedMessageId !== undefined && message.retractedMessageId !== "") {
      obj.retractedMessageId = message.retractedMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMessageRetractedDetails>, I>>(base?: I): LiveChatMessageRetractedDetails {
    return LiveChatMessageRetractedDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMessageRetractedDetails>, I>>(
    object: I,
  ): LiveChatMessageRetractedDetails {
    const message = createBaseLiveChatMessageRetractedDetails();
    message.retractedMessageId = object.retractedMessageId ?? "";
    return message;
  },
};

function createBaseLiveChatUserBannedMessageDetails(): LiveChatUserBannedMessageDetails {
  return { bannedUserDetails: undefined, banType: 1, banDurationSeconds: 0 };
}

export const LiveChatUserBannedMessageDetails: MessageFns<LiveChatUserBannedMessageDetails> = {
  encode(message: LiveChatUserBannedMessageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bannedUserDetails !== undefined) {
      ChannelProfileDetails.encode(message.bannedUserDetails, writer.uint32(10).fork()).join();
    }
    if (message.banType !== undefined && message.banType !== 1) {
      writer.uint32(16).int32(message.banType);
    }
    if (message.banDurationSeconds !== undefined && message.banDurationSeconds !== 0) {
      writer.uint32(32).uint64(message.banDurationSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatUserBannedMessageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatUserBannedMessageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bannedUserDetails = ChannelProfileDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.banType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.banDurationSeconds = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatUserBannedMessageDetails {
    return {
      bannedUserDetails: isSet(object.bannedUserDetails)
        ? ChannelProfileDetails.fromJSON(object.bannedUserDetails)
        : undefined,
      banType: isSet(object.banType)
        ? liveChatUserBannedMessageDetails_BanTypeWrapper_BanTypeFromJSON(object.banType)
        : 1,
      banDurationSeconds: isSet(object.banDurationSeconds) ? globalThis.Number(object.banDurationSeconds) : 0,
    };
  },

  toJSON(message: LiveChatUserBannedMessageDetails): unknown {
    const obj: any = {};
    if (message.bannedUserDetails !== undefined) {
      obj.bannedUserDetails = ChannelProfileDetails.toJSON(message.bannedUserDetails);
    }
    if (message.banType !== undefined && message.banType !== 1) {
      obj.banType = liveChatUserBannedMessageDetails_BanTypeWrapper_BanTypeToJSON(message.banType);
    }
    if (message.banDurationSeconds !== undefined && message.banDurationSeconds !== 0) {
      obj.banDurationSeconds = Math.round(message.banDurationSeconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatUserBannedMessageDetails>, I>>(
    base?: I,
  ): LiveChatUserBannedMessageDetails {
    return LiveChatUserBannedMessageDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatUserBannedMessageDetails>, I>>(
    object: I,
  ): LiveChatUserBannedMessageDetails {
    const message = createBaseLiveChatUserBannedMessageDetails();
    message.bannedUserDetails = (object.bannedUserDetails !== undefined && object.bannedUserDetails !== null)
      ? ChannelProfileDetails.fromPartial(object.bannedUserDetails)
      : undefined;
    message.banType = object.banType ?? 1;
    message.banDurationSeconds = object.banDurationSeconds ?? 0;
    return message;
  },
};

function createBaseLiveChatUserBannedMessageDetails_BanTypeWrapper(): LiveChatUserBannedMessageDetails_BanTypeWrapper {
  return {};
}

export const LiveChatUserBannedMessageDetails_BanTypeWrapper: MessageFns<
  LiveChatUserBannedMessageDetails_BanTypeWrapper
> = {
  encode(_: LiveChatUserBannedMessageDetails_BanTypeWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatUserBannedMessageDetails_BanTypeWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatUserBannedMessageDetails_BanTypeWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LiveChatUserBannedMessageDetails_BanTypeWrapper {
    return {};
  },

  toJSON(_: LiveChatUserBannedMessageDetails_BanTypeWrapper): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatUserBannedMessageDetails_BanTypeWrapper>, I>>(
    base?: I,
  ): LiveChatUserBannedMessageDetails_BanTypeWrapper {
    return LiveChatUserBannedMessageDetails_BanTypeWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatUserBannedMessageDetails_BanTypeWrapper>, I>>(
    _: I,
  ): LiveChatUserBannedMessageDetails_BanTypeWrapper {
    const message = createBaseLiveChatUserBannedMessageDetails_BanTypeWrapper();
    return message;
  },
};

function createBaseLiveChatSuperChatDetails(): LiveChatSuperChatDetails {
  return { amountMicros: 0, currency: "", amountDisplayString: "", userComment: "", tier: 0 };
}

export const LiveChatSuperChatDetails: MessageFns<LiveChatSuperChatDetails> = {
  encode(message: LiveChatSuperChatDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      writer.uint32(8).uint64(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      writer.uint32(18).string(message.currency);
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      writer.uint32(26).string(message.amountDisplayString);
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      writer.uint32(34).string(message.userComment);
    }
    if (message.tier !== undefined && message.tier !== 0) {
      writer.uint32(40).uint32(message.tier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatSuperChatDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatSuperChatDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.amountMicros = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.amountDisplayString = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.userComment = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatSuperChatDetails {
    return {
      amountMicros: isSet(object.amountMicros) ? globalThis.Number(object.amountMicros) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      amountDisplayString: isSet(object.amountDisplayString) ? globalThis.String(object.amountDisplayString) : "",
      userComment: isSet(object.userComment) ? globalThis.String(object.userComment) : "",
      tier: isSet(object.tier) ? globalThis.Number(object.tier) : 0,
    };
  },

  toJSON(message: LiveChatSuperChatDetails): unknown {
    const obj: any = {};
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      obj.amountMicros = Math.round(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      obj.amountDisplayString = message.amountDisplayString;
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      obj.userComment = message.userComment;
    }
    if (message.tier !== undefined && message.tier !== 0) {
      obj.tier = Math.round(message.tier);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatSuperChatDetails>, I>>(base?: I): LiveChatSuperChatDetails {
    return LiveChatSuperChatDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatSuperChatDetails>, I>>(object: I): LiveChatSuperChatDetails {
    const message = createBaseLiveChatSuperChatDetails();
    message.amountMicros = object.amountMicros ?? 0;
    message.currency = object.currency ?? "";
    message.amountDisplayString = object.amountDisplayString ?? "";
    message.userComment = object.userComment ?? "";
    message.tier = object.tier ?? 0;
    return message;
  },
};

function createBaseLiveChatSuperStickerDetails(): LiveChatSuperStickerDetails {
  return { amountMicros: 0, currency: "", amountDisplayString: "", tier: 0, superStickerMetadata: undefined };
}

export const LiveChatSuperStickerDetails: MessageFns<LiveChatSuperStickerDetails> = {
  encode(message: LiveChatSuperStickerDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      writer.uint32(8).uint64(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      writer.uint32(18).string(message.currency);
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      writer.uint32(26).string(message.amountDisplayString);
    }
    if (message.tier !== undefined && message.tier !== 0) {
      writer.uint32(32).uint32(message.tier);
    }
    if (message.superStickerMetadata !== undefined) {
      SuperStickerMetadata.encode(message.superStickerMetadata, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatSuperStickerDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatSuperStickerDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.amountMicros = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.amountDisplayString = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tier = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.superStickerMetadata = SuperStickerMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatSuperStickerDetails {
    return {
      amountMicros: isSet(object.amountMicros) ? globalThis.Number(object.amountMicros) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      amountDisplayString: isSet(object.amountDisplayString) ? globalThis.String(object.amountDisplayString) : "",
      tier: isSet(object.tier) ? globalThis.Number(object.tier) : 0,
      superStickerMetadata: isSet(object.superStickerMetadata)
        ? SuperStickerMetadata.fromJSON(object.superStickerMetadata)
        : undefined,
    };
  },

  toJSON(message: LiveChatSuperStickerDetails): unknown {
    const obj: any = {};
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      obj.amountMicros = Math.round(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      obj.amountDisplayString = message.amountDisplayString;
    }
    if (message.tier !== undefined && message.tier !== 0) {
      obj.tier = Math.round(message.tier);
    }
    if (message.superStickerMetadata !== undefined) {
      obj.superStickerMetadata = SuperStickerMetadata.toJSON(message.superStickerMetadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatSuperStickerDetails>, I>>(base?: I): LiveChatSuperStickerDetails {
    return LiveChatSuperStickerDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatSuperStickerDetails>, I>>(object: I): LiveChatSuperStickerDetails {
    const message = createBaseLiveChatSuperStickerDetails();
    message.amountMicros = object.amountMicros ?? 0;
    message.currency = object.currency ?? "";
    message.amountDisplayString = object.amountDisplayString ?? "";
    message.tier = object.tier ?? 0;
    message.superStickerMetadata = (object.superStickerMetadata !== undefined && object.superStickerMetadata !== null)
      ? SuperStickerMetadata.fromPartial(object.superStickerMetadata)
      : undefined;
    return message;
  },
};

function createBaseLiveChatFanFundingEventDetails(): LiveChatFanFundingEventDetails {
  return { amountMicros: 0, currency: "", amountDisplayString: "", userComment: "" };
}

export const LiveChatFanFundingEventDetails: MessageFns<LiveChatFanFundingEventDetails> = {
  encode(message: LiveChatFanFundingEventDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      writer.uint32(8).uint64(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      writer.uint32(18).string(message.currency);
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      writer.uint32(26).string(message.amountDisplayString);
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      writer.uint32(34).string(message.userComment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatFanFundingEventDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatFanFundingEventDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.amountMicros = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.amountDisplayString = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.userComment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatFanFundingEventDetails {
    return {
      amountMicros: isSet(object.amountMicros) ? globalThis.Number(object.amountMicros) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      amountDisplayString: isSet(object.amountDisplayString) ? globalThis.String(object.amountDisplayString) : "",
      userComment: isSet(object.userComment) ? globalThis.String(object.userComment) : "",
    };
  },

  toJSON(message: LiveChatFanFundingEventDetails): unknown {
    const obj: any = {};
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      obj.amountMicros = Math.round(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.amountDisplayString !== undefined && message.amountDisplayString !== "") {
      obj.amountDisplayString = message.amountDisplayString;
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      obj.userComment = message.userComment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatFanFundingEventDetails>, I>>(base?: I): LiveChatFanFundingEventDetails {
    return LiveChatFanFundingEventDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatFanFundingEventDetails>, I>>(
    object: I,
  ): LiveChatFanFundingEventDetails {
    const message = createBaseLiveChatFanFundingEventDetails();
    message.amountMicros = object.amountMicros ?? 0;
    message.currency = object.currency ?? "";
    message.amountDisplayString = object.amountDisplayString ?? "";
    message.userComment = object.userComment ?? "";
    return message;
  },
};

function createBaseLiveChatNewSponsorDetails(): LiveChatNewSponsorDetails {
  return { memberLevelName: "", isUpgrade: false };
}

export const LiveChatNewSponsorDetails: MessageFns<LiveChatNewSponsorDetails> = {
  encode(message: LiveChatNewSponsorDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      writer.uint32(10).string(message.memberLevelName);
    }
    if (message.isUpgrade !== undefined && message.isUpgrade !== false) {
      writer.uint32(16).bool(message.isUpgrade);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatNewSponsorDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatNewSponsorDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.memberLevelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isUpgrade = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatNewSponsorDetails {
    return {
      memberLevelName: isSet(object.memberLevelName) ? globalThis.String(object.memberLevelName) : "",
      isUpgrade: isSet(object.isUpgrade) ? globalThis.Boolean(object.isUpgrade) : false,
    };
  },

  toJSON(message: LiveChatNewSponsorDetails): unknown {
    const obj: any = {};
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      obj.memberLevelName = message.memberLevelName;
    }
    if (message.isUpgrade !== undefined && message.isUpgrade !== false) {
      obj.isUpgrade = message.isUpgrade;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatNewSponsorDetails>, I>>(base?: I): LiveChatNewSponsorDetails {
    return LiveChatNewSponsorDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatNewSponsorDetails>, I>>(object: I): LiveChatNewSponsorDetails {
    const message = createBaseLiveChatNewSponsorDetails();
    message.memberLevelName = object.memberLevelName ?? "";
    message.isUpgrade = object.isUpgrade ?? false;
    return message;
  },
};

function createBaseLiveChatMemberMilestoneChatDetails(): LiveChatMemberMilestoneChatDetails {
  return { memberLevelName: "", memberMonth: 0, userComment: "" };
}

export const LiveChatMemberMilestoneChatDetails: MessageFns<LiveChatMemberMilestoneChatDetails> = {
  encode(message: LiveChatMemberMilestoneChatDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      writer.uint32(10).string(message.memberLevelName);
    }
    if (message.memberMonth !== undefined && message.memberMonth !== 0) {
      writer.uint32(16).uint32(message.memberMonth);
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      writer.uint32(26).string(message.userComment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMemberMilestoneChatDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMemberMilestoneChatDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.memberLevelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.memberMonth = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.userComment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMemberMilestoneChatDetails {
    return {
      memberLevelName: isSet(object.memberLevelName) ? globalThis.String(object.memberLevelName) : "",
      memberMonth: isSet(object.memberMonth) ? globalThis.Number(object.memberMonth) : 0,
      userComment: isSet(object.userComment) ? globalThis.String(object.userComment) : "",
    };
  },

  toJSON(message: LiveChatMemberMilestoneChatDetails): unknown {
    const obj: any = {};
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      obj.memberLevelName = message.memberLevelName;
    }
    if (message.memberMonth !== undefined && message.memberMonth !== 0) {
      obj.memberMonth = Math.round(message.memberMonth);
    }
    if (message.userComment !== undefined && message.userComment !== "") {
      obj.userComment = message.userComment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMemberMilestoneChatDetails>, I>>(
    base?: I,
  ): LiveChatMemberMilestoneChatDetails {
    return LiveChatMemberMilestoneChatDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMemberMilestoneChatDetails>, I>>(
    object: I,
  ): LiveChatMemberMilestoneChatDetails {
    const message = createBaseLiveChatMemberMilestoneChatDetails();
    message.memberLevelName = object.memberLevelName ?? "";
    message.memberMonth = object.memberMonth ?? 0;
    message.userComment = object.userComment ?? "";
    return message;
  },
};

function createBaseLiveChatMembershipGiftingDetails(): LiveChatMembershipGiftingDetails {
  return { giftMembershipsCount: 0, giftMembershipsLevelName: "" };
}

export const LiveChatMembershipGiftingDetails: MessageFns<LiveChatMembershipGiftingDetails> = {
  encode(message: LiveChatMembershipGiftingDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.giftMembershipsCount !== undefined && message.giftMembershipsCount !== 0) {
      writer.uint32(8).int32(message.giftMembershipsCount);
    }
    if (message.giftMembershipsLevelName !== undefined && message.giftMembershipsLevelName !== "") {
      writer.uint32(18).string(message.giftMembershipsLevelName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatMembershipGiftingDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatMembershipGiftingDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.giftMembershipsCount = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.giftMembershipsLevelName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatMembershipGiftingDetails {
    return {
      giftMembershipsCount: isSet(object.giftMembershipsCount) ? globalThis.Number(object.giftMembershipsCount) : 0,
      giftMembershipsLevelName: isSet(object.giftMembershipsLevelName)
        ? globalThis.String(object.giftMembershipsLevelName)
        : "",
    };
  },

  toJSON(message: LiveChatMembershipGiftingDetails): unknown {
    const obj: any = {};
    if (message.giftMembershipsCount !== undefined && message.giftMembershipsCount !== 0) {
      obj.giftMembershipsCount = Math.round(message.giftMembershipsCount);
    }
    if (message.giftMembershipsLevelName !== undefined && message.giftMembershipsLevelName !== "") {
      obj.giftMembershipsLevelName = message.giftMembershipsLevelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatMembershipGiftingDetails>, I>>(
    base?: I,
  ): LiveChatMembershipGiftingDetails {
    return LiveChatMembershipGiftingDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatMembershipGiftingDetails>, I>>(
    object: I,
  ): LiveChatMembershipGiftingDetails {
    const message = createBaseLiveChatMembershipGiftingDetails();
    message.giftMembershipsCount = object.giftMembershipsCount ?? 0;
    message.giftMembershipsLevelName = object.giftMembershipsLevelName ?? "";
    return message;
  },
};

function createBaseLiveChatGiftMembershipReceivedDetails(): LiveChatGiftMembershipReceivedDetails {
  return { memberLevelName: "", gifterChannelId: "", associatedMembershipGiftingMessageId: "" };
}

export const LiveChatGiftMembershipReceivedDetails: MessageFns<LiveChatGiftMembershipReceivedDetails> = {
  encode(message: LiveChatGiftMembershipReceivedDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      writer.uint32(10).string(message.memberLevelName);
    }
    if (message.gifterChannelId !== undefined && message.gifterChannelId !== "") {
      writer.uint32(18).string(message.gifterChannelId);
    }
    if (
      message.associatedMembershipGiftingMessageId !== undefined && message.associatedMembershipGiftingMessageId !== ""
    ) {
      writer.uint32(26).string(message.associatedMembershipGiftingMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatGiftMembershipReceivedDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatGiftMembershipReceivedDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.memberLevelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.gifterChannelId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.associatedMembershipGiftingMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatGiftMembershipReceivedDetails {
    return {
      memberLevelName: isSet(object.memberLevelName) ? globalThis.String(object.memberLevelName) : "",
      gifterChannelId: isSet(object.gifterChannelId) ? globalThis.String(object.gifterChannelId) : "",
      associatedMembershipGiftingMessageId: isSet(object.associatedMembershipGiftingMessageId)
        ? globalThis.String(object.associatedMembershipGiftingMessageId)
        : "",
    };
  },

  toJSON(message: LiveChatGiftMembershipReceivedDetails): unknown {
    const obj: any = {};
    if (message.memberLevelName !== undefined && message.memberLevelName !== "") {
      obj.memberLevelName = message.memberLevelName;
    }
    if (message.gifterChannelId !== undefined && message.gifterChannelId !== "") {
      obj.gifterChannelId = message.gifterChannelId;
    }
    if (
      message.associatedMembershipGiftingMessageId !== undefined && message.associatedMembershipGiftingMessageId !== ""
    ) {
      obj.associatedMembershipGiftingMessageId = message.associatedMembershipGiftingMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatGiftMembershipReceivedDetails>, I>>(
    base?: I,
  ): LiveChatGiftMembershipReceivedDetails {
    return LiveChatGiftMembershipReceivedDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatGiftMembershipReceivedDetails>, I>>(
    object: I,
  ): LiveChatGiftMembershipReceivedDetails {
    const message = createBaseLiveChatGiftMembershipReceivedDetails();
    message.memberLevelName = object.memberLevelName ?? "";
    message.gifterChannelId = object.gifterChannelId ?? "";
    message.associatedMembershipGiftingMessageId = object.associatedMembershipGiftingMessageId ?? "";
    return message;
  },
};

function createBaseLiveChatPollDetails(): LiveChatPollDetails {
  return { metadata: undefined, status: 0 };
}

export const LiveChatPollDetails: MessageFns<LiveChatPollDetails> = {
  encode(message: LiveChatPollDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      LiveChatPollDetails_PollMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.status !== undefined && message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatPollDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatPollDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = LiveChatPollDetails_PollMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatPollDetails {
    return {
      metadata: isSet(object.metadata) ? LiveChatPollDetails_PollMetadata.fromJSON(object.metadata) : undefined,
      status: isSet(object.status) ? liveChatPollDetails_PollStatusWrapper_PollStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: LiveChatPollDetails): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = LiveChatPollDetails_PollMetadata.toJSON(message.metadata);
    }
    if (message.status !== undefined && message.status !== 0) {
      obj.status = liveChatPollDetails_PollStatusWrapper_PollStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatPollDetails>, I>>(base?: I): LiveChatPollDetails {
    return LiveChatPollDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatPollDetails>, I>>(object: I): LiveChatPollDetails {
    const message = createBaseLiveChatPollDetails();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? LiveChatPollDetails_PollMetadata.fromPartial(object.metadata)
      : undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseLiveChatPollDetails_PollMetadata(): LiveChatPollDetails_PollMetadata {
  return { questionText: "", options: [] };
}

export const LiveChatPollDetails_PollMetadata: MessageFns<LiveChatPollDetails_PollMetadata> = {
  encode(message: LiveChatPollDetails_PollMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.questionText !== undefined && message.questionText !== "") {
      writer.uint32(10).string(message.questionText);
    }
    for (const v of message.options) {
      LiveChatPollDetails_PollMetadata_PollOption.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatPollDetails_PollMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatPollDetails_PollMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.questionText = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.options.push(LiveChatPollDetails_PollMetadata_PollOption.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatPollDetails_PollMetadata {
    return {
      questionText: isSet(object.questionText) ? globalThis.String(object.questionText) : "",
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => LiveChatPollDetails_PollMetadata_PollOption.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LiveChatPollDetails_PollMetadata): unknown {
    const obj: any = {};
    if (message.questionText !== undefined && message.questionText !== "") {
      obj.questionText = message.questionText;
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => LiveChatPollDetails_PollMetadata_PollOption.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatPollDetails_PollMetadata>, I>>(
    base?: I,
  ): LiveChatPollDetails_PollMetadata {
    return LiveChatPollDetails_PollMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatPollDetails_PollMetadata>, I>>(
    object: I,
  ): LiveChatPollDetails_PollMetadata {
    const message = createBaseLiveChatPollDetails_PollMetadata();
    message.questionText = object.questionText ?? "";
    message.options = object.options?.map((e) => LiveChatPollDetails_PollMetadata_PollOption.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLiveChatPollDetails_PollMetadata_PollOption(): LiveChatPollDetails_PollMetadata_PollOption {
  return { optionText: "", tally: 0 };
}

export const LiveChatPollDetails_PollMetadata_PollOption: MessageFns<LiveChatPollDetails_PollMetadata_PollOption> = {
  encode(
    message: LiveChatPollDetails_PollMetadata_PollOption,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.optionText !== undefined && message.optionText !== "") {
      writer.uint32(10).string(message.optionText);
    }
    if (message.tally !== undefined && message.tally !== 0) {
      writer.uint32(16).int64(message.tally);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatPollDetails_PollMetadata_PollOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatPollDetails_PollMetadata_PollOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.optionText = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tally = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveChatPollDetails_PollMetadata_PollOption {
    return {
      optionText: isSet(object.optionText) ? globalThis.String(object.optionText) : "",
      tally: isSet(object.tally) ? globalThis.Number(object.tally) : 0,
    };
  },

  toJSON(message: LiveChatPollDetails_PollMetadata_PollOption): unknown {
    const obj: any = {};
    if (message.optionText !== undefined && message.optionText !== "") {
      obj.optionText = message.optionText;
    }
    if (message.tally !== undefined && message.tally !== 0) {
      obj.tally = Math.round(message.tally);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatPollDetails_PollMetadata_PollOption>, I>>(
    base?: I,
  ): LiveChatPollDetails_PollMetadata_PollOption {
    return LiveChatPollDetails_PollMetadata_PollOption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatPollDetails_PollMetadata_PollOption>, I>>(
    object: I,
  ): LiveChatPollDetails_PollMetadata_PollOption {
    const message = createBaseLiveChatPollDetails_PollMetadata_PollOption();
    message.optionText = object.optionText ?? "";
    message.tally = object.tally ?? 0;
    return message;
  },
};

function createBaseLiveChatPollDetails_PollStatusWrapper(): LiveChatPollDetails_PollStatusWrapper {
  return {};
}

export const LiveChatPollDetails_PollStatusWrapper: MessageFns<LiveChatPollDetails_PollStatusWrapper> = {
  encode(_: LiveChatPollDetails_PollStatusWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveChatPollDetails_PollStatusWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveChatPollDetails_PollStatusWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LiveChatPollDetails_PollStatusWrapper {
    return {};
  },

  toJSON(_: LiveChatPollDetails_PollStatusWrapper): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveChatPollDetails_PollStatusWrapper>, I>>(
    base?: I,
  ): LiveChatPollDetails_PollStatusWrapper {
    return LiveChatPollDetails_PollStatusWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveChatPollDetails_PollStatusWrapper>, I>>(
    _: I,
  ): LiveChatPollDetails_PollStatusWrapper {
    const message = createBaseLiveChatPollDetails_PollStatusWrapper();
    return message;
  },
};

function createBaseSuperChatEventSnippet(): SuperChatEventSnippet {
  return {
    channelId: "",
    supporterDetails: undefined,
    commentText: "",
    createdAt: "",
    amountMicros: 0,
    currency: "",
    displayString: "",
    messageType: 0,
    isSuperStickerEvent: false,
    superStickerMetadata: undefined,
  };
}

export const SuperChatEventSnippet: MessageFns<SuperChatEventSnippet> = {
  encode(message: SuperChatEventSnippet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelId !== undefined && message.channelId !== "") {
      writer.uint32(810).string(message.channelId);
    }
    if (message.supporterDetails !== undefined) {
      ChannelProfileDetails.encode(message.supporterDetails, writer.uint32(18).fork()).join();
    }
    if (message.commentText !== undefined && message.commentText !== "") {
      writer.uint32(26).string(message.commentText);
    }
    if (message.createdAt !== undefined && message.createdAt !== "") {
      writer.uint32(34).string(message.createdAt);
    }
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      writer.uint32(40).uint64(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      writer.uint32(50).string(message.currency);
    }
    if (message.displayString !== undefined && message.displayString !== "") {
      writer.uint32(58).string(message.displayString);
    }
    if (message.messageType !== undefined && message.messageType !== 0) {
      writer.uint32(64).uint32(message.messageType);
    }
    if (message.isSuperStickerEvent !== undefined && message.isSuperStickerEvent !== false) {
      writer.uint32(88).bool(message.isSuperStickerEvent);
    }
    if (message.superStickerMetadata !== undefined) {
      SuperStickerMetadata.encode(message.superStickerMetadata, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SuperChatEventSnippet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperChatEventSnippet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.supporterDetails = ChannelProfileDetails.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commentText = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.amountMicros = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.displayString = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.messageType = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.isSuperStickerEvent = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.superStickerMetadata = SuperStickerMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperChatEventSnippet {
    return {
      channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
      supporterDetails: isSet(object.supporterDetails)
        ? ChannelProfileDetails.fromJSON(object.supporterDetails)
        : undefined,
      commentText: isSet(object.commentText) ? globalThis.String(object.commentText) : "",
      createdAt: isSet(object.createdAt) ? globalThis.String(object.createdAt) : "",
      amountMicros: isSet(object.amountMicros) ? globalThis.Number(object.amountMicros) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      displayString: isSet(object.displayString) ? globalThis.String(object.displayString) : "",
      messageType: isSet(object.messageType) ? globalThis.Number(object.messageType) : 0,
      isSuperStickerEvent: isSet(object.isSuperStickerEvent) ? globalThis.Boolean(object.isSuperStickerEvent) : false,
      superStickerMetadata: isSet(object.superStickerMetadata)
        ? SuperStickerMetadata.fromJSON(object.superStickerMetadata)
        : undefined,
    };
  },

  toJSON(message: SuperChatEventSnippet): unknown {
    const obj: any = {};
    if (message.channelId !== undefined && message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.supporterDetails !== undefined) {
      obj.supporterDetails = ChannelProfileDetails.toJSON(message.supporterDetails);
    }
    if (message.commentText !== undefined && message.commentText !== "") {
      obj.commentText = message.commentText;
    }
    if (message.createdAt !== undefined && message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.amountMicros !== undefined && message.amountMicros !== 0) {
      obj.amountMicros = Math.round(message.amountMicros);
    }
    if (message.currency !== undefined && message.currency !== "") {
      obj.currency = message.currency;
    }
    if (message.displayString !== undefined && message.displayString !== "") {
      obj.displayString = message.displayString;
    }
    if (message.messageType !== undefined && message.messageType !== 0) {
      obj.messageType = Math.round(message.messageType);
    }
    if (message.isSuperStickerEvent !== undefined && message.isSuperStickerEvent !== false) {
      obj.isSuperStickerEvent = message.isSuperStickerEvent;
    }
    if (message.superStickerMetadata !== undefined) {
      obj.superStickerMetadata = SuperStickerMetadata.toJSON(message.superStickerMetadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperChatEventSnippet>, I>>(base?: I): SuperChatEventSnippet {
    return SuperChatEventSnippet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperChatEventSnippet>, I>>(object: I): SuperChatEventSnippet {
    const message = createBaseSuperChatEventSnippet();
    message.channelId = object.channelId ?? "";
    message.supporterDetails = (object.supporterDetails !== undefined && object.supporterDetails !== null)
      ? ChannelProfileDetails.fromPartial(object.supporterDetails)
      : undefined;
    message.commentText = object.commentText ?? "";
    message.createdAt = object.createdAt ?? "";
    message.amountMicros = object.amountMicros ?? 0;
    message.currency = object.currency ?? "";
    message.displayString = object.displayString ?? "";
    message.messageType = object.messageType ?? 0;
    message.isSuperStickerEvent = object.isSuperStickerEvent ?? false;
    message.superStickerMetadata = (object.superStickerMetadata !== undefined && object.superStickerMetadata !== null)
      ? SuperStickerMetadata.fromPartial(object.superStickerMetadata)
      : undefined;
    return message;
  },
};

function createBaseSuperStickerMetadata(): SuperStickerMetadata {
  return { stickerId: "", altText: "", altTextLanguage: "" };
}

export const SuperStickerMetadata: MessageFns<SuperStickerMetadata> = {
  encode(message: SuperStickerMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stickerId !== undefined && message.stickerId !== "") {
      writer.uint32(10).string(message.stickerId);
    }
    if (message.altText !== undefined && message.altText !== "") {
      writer.uint32(18).string(message.altText);
    }
    if (message.altTextLanguage !== undefined && message.altTextLanguage !== "") {
      writer.uint32(26).string(message.altTextLanguage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SuperStickerMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSuperStickerMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stickerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.altText = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.altTextLanguage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SuperStickerMetadata {
    return {
      stickerId: isSet(object.stickerId) ? globalThis.String(object.stickerId) : "",
      altText: isSet(object.altText) ? globalThis.String(object.altText) : "",
      altTextLanguage: isSet(object.altTextLanguage) ? globalThis.String(object.altTextLanguage) : "",
    };
  },

  toJSON(message: SuperStickerMetadata): unknown {
    const obj: any = {};
    if (message.stickerId !== undefined && message.stickerId !== "") {
      obj.stickerId = message.stickerId;
    }
    if (message.altText !== undefined && message.altText !== "") {
      obj.altText = message.altText;
    }
    if (message.altTextLanguage !== undefined && message.altTextLanguage !== "") {
      obj.altTextLanguage = message.altTextLanguage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SuperStickerMetadata>, I>>(base?: I): SuperStickerMetadata {
    return SuperStickerMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SuperStickerMetadata>, I>>(object: I): SuperStickerMetadata {
    const message = createBaseSuperStickerMetadata();
    message.stickerId = object.stickerId ?? "";
    message.altText = object.altText ?? "";
    message.altTextLanguage = object.altTextLanguage ?? "";
    return message;
  },
};

function createBaseChannelProfileDetails(): ChannelProfileDetails {
  return { channelId: "", channelUrl: "", displayName: "", profileImageUrl: "" };
}

export const ChannelProfileDetails: MessageFns<ChannelProfileDetails> = {
  encode(message: ChannelProfileDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channelId !== undefined && message.channelId !== "") {
      writer.uint32(810).string(message.channelId);
    }
    if (message.channelUrl !== undefined && message.channelUrl !== "") {
      writer.uint32(18).string(message.channelUrl);
    }
    if (message.displayName !== undefined && message.displayName !== "") {
      writer.uint32(26).string(message.displayName);
    }
    if (message.profileImageUrl !== undefined && message.profileImageUrl !== "") {
      writer.uint32(34).string(message.profileImageUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelProfileDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelProfileDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channelUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.profileImageUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelProfileDetails {
    return {
      channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
      channelUrl: isSet(object.channelUrl) ? globalThis.String(object.channelUrl) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      profileImageUrl: isSet(object.profileImageUrl) ? globalThis.String(object.profileImageUrl) : "",
    };
  },

  toJSON(message: ChannelProfileDetails): unknown {
    const obj: any = {};
    if (message.channelId !== undefined && message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.channelUrl !== undefined && message.channelUrl !== "") {
      obj.channelUrl = message.channelUrl;
    }
    if (message.displayName !== undefined && message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.profileImageUrl !== undefined && message.profileImageUrl !== "") {
      obj.profileImageUrl = message.profileImageUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelProfileDetails>, I>>(base?: I): ChannelProfileDetails {
    return ChannelProfileDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelProfileDetails>, I>>(object: I): ChannelProfileDetails {
    const message = createBaseChannelProfileDetails();
    message.channelId = object.channelId ?? "";
    message.channelUrl = object.channelUrl ?? "";
    message.displayName = object.displayName ?? "";
    message.profileImageUrl = object.profileImageUrl ?? "";
    return message;
  },
};

function createBasePageInfo(): PageInfo {
  return { totalResults: 0, resultsPerPage: 0 };
}

export const PageInfo: MessageFns<PageInfo> = {
  encode(message: PageInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalResults !== undefined && message.totalResults !== 0) {
      writer.uint32(8).int32(message.totalResults);
    }
    if (message.resultsPerPage !== undefined && message.resultsPerPage !== 0) {
      writer.uint32(16).int32(message.resultsPerPage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PageInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePageInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalResults = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.resultsPerPage = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PageInfo {
    return {
      totalResults: isSet(object.totalResults) ? globalThis.Number(object.totalResults) : 0,
      resultsPerPage: isSet(object.resultsPerPage) ? globalThis.Number(object.resultsPerPage) : 0,
    };
  },

  toJSON(message: PageInfo): unknown {
    const obj: any = {};
    if (message.totalResults !== undefined && message.totalResults !== 0) {
      obj.totalResults = Math.round(message.totalResults);
    }
    if (message.resultsPerPage !== undefined && message.resultsPerPage !== 0) {
      obj.resultsPerPage = Math.round(message.resultsPerPage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PageInfo>, I>>(base?: I): PageInfo {
    return PageInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PageInfo>, I>>(object: I): PageInfo {
    const message = createBasePageInfo();
    message.totalResults = object.totalResults ?? 0;
    message.resultsPerPage = object.resultsPerPage ?? 0;
    return message;
  },
};

export interface V3DataLiveChatMessageService {
  /** Allows a user to load live chat through a server-streamed RPC. */
  StreamList(
    request: DeepPartial<LiveChatMessageListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<LiveChatMessageListResponse>;
}

export class V3DataLiveChatMessageServiceClientImpl implements V3DataLiveChatMessageService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.StreamList = this.StreamList.bind(this);
  }

  StreamList(
    request: DeepPartial<LiveChatMessageListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<LiveChatMessageListResponse> {
    return this.rpc.invoke(
      V3DataLiveChatMessageServiceStreamListDesc,
      LiveChatMessageListRequest.fromPartial(request),
      metadata,
    );
  }
}

export const V3DataLiveChatMessageServiceDesc = { serviceName: "youtube.api.v3.V3DataLiveChatMessageService" };

export const V3DataLiveChatMessageServiceStreamListDesc: UnaryMethodDefinitionish = {
  methodName: "StreamList",
  service: V3DataLiveChatMessageServiceDesc,
  requestStream: false,
  responseStream: true,
  requestType: {
    serializeBinary() {
      return LiveChatMessageListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = LiveChatMessageListResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
  invoke<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;
    streamingTransport?: grpc.TransportFactory;
    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;
      streamingTransport?: grpc.TransportFactory;
      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (response) => {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }

  invoke<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const upStreamCodes = this.options.upStreamRetryCodes ?? [];
    const DEFAULT_TIMEOUT_TIME: number = 3_000;
    const request = { ..._request, ...methodDesc.requestType };
    const transport = this.options.streamingTransport ?? this.options.transport;
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      const upStream = () => {
        const client = grpc.invoke(methodDesc, {
          host: this.host,
          request,
          ...(transport !== undefined ? { transport } : {}),
          metadata: maybeCombinedMetadata ?? {},
          debug: this.options.debug ?? false,
          onMessage: (next) => observer.next(next),
          onEnd: (code: grpc.Code, message: string, trailers: grpc.Metadata) => {
            if (code === 0) {
              observer.complete();
            } else if (upStreamCodes.includes(code)) {
              setTimeout(upStream, DEFAULT_TIMEOUT_TIME);
            } else {
              const err = new Error(message) as any;
              err.code = code;
              err.metadata = trailers;
              observer.error(err);
            }
          },
        });
        observer.add(() => client.close());
      };
      upStream();
    }).pipe(share());
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
